import { render, staticRenderFns } from "./NinteenTable.vue?vue&type=template&id=4f5826ae&"
import script from "./NinteenTable.vue?vue&type=script&lang=js&"
export * from "./NinteenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports